<div class="recipient-dialog admin-panel-recipients">
  <div class="recipient-filters" [formGroup]="searchForm">
    <div class="recipient-filters__title">Filtrowanie zaawansowane</div>
    <app-info-message class="block mb-3">
      <div class="recipient-search-info flex flex-col gap-2 mb-4">
        <p class="m-0">W celu wyszukania użytkownika należy:</p>
        <ol class="m-0 pl-5 list-decimal">
          <li>Podać numer PESEL lub</li>
          <li>
            Podać Imię i Nazwisko oraz jedną z poniższych danych:
            <ol class="pl-5 mt-1 list-[lower-alpha]">
              <li>Seria i numer dokumentu tożsamości</li>
              <li>Data urodzenia</li>
              <li>Adres e-mail</li>
              <li>Miejscowość z adresu zamieszkania</li>
            </ol>
          </li>
        </ol>
        <p class="m-0">
          Po wprowadzeniu parametrów wyszukiwania należy wskazać powód
          wyszukiwania danego użytkownika.
        </p>
      </div>
    </app-info-message>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div class="flex flex-col gap-2">
        <label for="recipient-pesel" class="field-label">PESEL</label>
        <input
          id="recipient-pesel"
          pInputText
          formControlName="pesel"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-first-name" class="field-label">Imię</label>
        <input
          id="recipient-first-name"
          pInputText
          formControlName="firstName"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-last-name" class="field-label">Nazwisko</label>
        <input
          id="recipient-last-name"
          pInputText
          formControlName="lastName"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-document" class="field-label"
          >Seria i numer dowodu tożsamości</label
        >
        <input
          id="recipient-document"
          pInputText
          formControlName="documentNumber"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-birth-date" class="field-label"
          >Data urodzenia</label
        >
        <p-date-picker
          id="recipient-birth-date"
          inputId="recipient-birth-date"
          formControlName="birthDate"
          dateFormat="yy-mm-dd"
          appendTo="body"
          class="w-full customDatePicker"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [maxDate]="today"
          appControlError
        ></p-date-picker>
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-email" class="field-label">Adres e-mail</label>
        <input
          id="recipient-email"
          pInputText
          formControlName="email"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="recipient-city" class="field-label"
          >Miejscowość z adresu zamieszkania</label
        >
        <input
          id="recipient-city"
          pInputText
          formControlName="city"
          appControlError
        />
      </div>
      <div class="flex flex-col gap-2">
        <span id="recipient-reason-label"
              class="field-label"
              appRequiredLabel="reason"
          >Powód wyszukiwania</span
        >
        <p-select
          id="recipient-reason"
          inputId="recipient-reason"
          [options]="reasonOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          formControlName="reason"
          ariaLabelledBy="recipient-reason-label"
          appControlError
        ></p-select>
      </div>
      <div class="flex items-end justify-end gap-2 md:col-span-1">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="onClearFilters()"
        ></p-button>
        <p-button
          type="button"
          label="Wyszukaj"
          styleClass="customInfoButton"
          (click)="onSearch()"
          [disabled]="searchForm.controls.reason.invalid"
        ></p-button>
      </div>
    </div>
    <div
      class="mt-2"
      appControlError
      [customErrorInput]="searchForm"
      [isInvalidCondition]="
        searchForm.invalid && (searchForm.dirty || searchForm.touched)
      "
    ></div>
  </div>

  <fieldset class="wide">
    <legend class="sr-only">Wybór adresata</legend>
    <p-table
      #table
      class="recipient-table"
      [lazy]="true"
      [value]="rows()"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [totalRecords]="tablePage()?.totalElements || 0"
      stripedRows
      dataKey="id"
      sortField="lastName"
      sortMode="single"
      [sortOrder]="1"
      (onSort)="onPrimeSortChange($event)"
    >
      <ng-template #caption>
        <span class="sr-only"
          >Lista adresatów dostępnych do wyboru dla komunikatu.</span
        >
      </ng-template>
      <ng-template #header>
        <tr>
          <th style="width: 2.5rem">
            <span class="sr-only">Wybierz adresata</span>
          </th>
          <th pSortableColumn="firstName">
            <span class="recipient-header">
              Imię
              <p-sortIcon field="firstName"></p-sortIcon>
              <i class="pi pi-filter" aria-hidden="true"></i>
            </span>
          </th>
          <th pSortableColumn="lastName">
            <span class="recipient-header">
              Nazwisko
              <p-sortIcon field="lastName"></p-sortIcon>
              <i class="pi pi-filter" aria-hidden="true"></i>
            </span>
          </th>
          <th pSortableColumn="email">
            <span class="recipient-header">
              Adres e-mail
              <p-sortIcon field="email"></p-sortIcon>
              <i class="pi pi-filter" aria-hidden="true"></i>
            </span>
          </th>
          <th pSortableColumn="lastLoginAt">
            <span class="recipient-header">
              Data ostatniego logowania
              <p-sortIcon field="lastLoginAt"></p-sortIcon>
              <i class="pi pi-filter" aria-hidden="true"></i>
            </span>
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr [pSelectableRow]="row">
          <td class="text-center">
            <p-checkbox
              [inputId]="'recipient-' + row.id"
              [binary]="true"
              [ngModel]="isRecipientSelected(row)"
              (ngModelChange)="toggleRecipient(row, $event)"
            ></p-checkbox>
            <label class="sr-only" [for]="'recipient-' + row.id">
              Wybierz adresata {{ row.firstName }} {{ row.lastName }}
            </label>
          </td>
          <td>{{ row.firstName }}</td>
          <td>{{ row.lastName }}</td>
          <td>
            <div class="flex flex-col gap-1">
              <span>{{ row.email }}</span>
              @if (!row.announcementsEmailConsent) {
                <span class="recipient-consent-warning">
                  Użytkownik nie wyraził zgody na otrzymywanie komunikatów za pomocą środków komunikacji elektronicznej.
                </span>
              }
            </div>
          </td>
          <td>{{ row.lastLoginAt | date: 'yyyy-MM-dd HH:mm' }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="5" class="text-center p-4 text-sm text-gray-500">
            @if (hasSearched()) {
              Brak rekordów do wyświetlenia.
            } @else {
              Wprowadź kryteria wyszukiwania i wybierz powód wyszukiwania
              danych.
            }
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex items-center justify-end mt-3">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        [rowsPerPageOptions]="[5, 10, 20]"
      ></p-paginator>
    </div>
  </fieldset>

  <fieldset class="narrow">
    <legend class="sr-only">Wybór adresata</legend>
    <div class="flex flex-col gap-4">
      @for (row of rows(); track row.id) {
        <p-card>
          <div class="flex items-start gap-3">
            <p-checkbox
              [inputId]="'recipient-mobile-' + row.id"
              [binary]="true"
              [ngModel]="isRecipientSelected(row)"
              (ngModelChange)="toggleRecipient(row, $event)"
            ></p-checkbox>
            <label class="sr-only" [for]="'recipient-mobile-' + row.id">
              Wybierz adresata {{ row.firstName }} {{ row.lastName }}
            </label>
            <div class="flex flex-col w-full">
              <app-preview-data-wrapper
                label="Imię"
                [data]="row.firstName"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Nazwisko"
                [data]="row.lastName"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Adres e-mail"
                [data]="row.email"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              @if (!row.announcementsEmailConsent) {
                <span class="recipient-consent-warning">
                  Użytkownik nie wyraził zgody na otrzymywanie komunikatów za pomocą środków komunikacji elektronicznej.
                </span>
              }
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Data ostatniego logowania"
                [data]="row.lastLoginAt"
                [dataType]="PreviewDataType.DATE_TIME"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
            </div>
          </div>
        </p-card>
      }
      @if (rows().length === 0) {
        <p-card>
          <div class="text-center text-sm text-gray-500 py-4">
            @if (hasSearched()) {
              Brak rekordów do wyświetlenia.
            } @else {
              Wprowadź kryteria wyszukiwania i wybierz powód wyszukiwania
              danych.
            }
          </div>
        </p-card>
      }
      <div class="flex items-center justify-end">
        <p-paginator
          (onPageChange)="onPrimePageChange($event)"
          [rows]="tablePage()?.size || 10"
          [totalRecords]="tablePage()?.totalElements || 0"
          [rowsPerPageOptions]="[5, 10, 20]"
        ></p-paginator>
      </div>
    </div>
  </fieldset>

  <div class="flex items-center justify-end gap-2 mt-4">
    <p-button
      type="button"
      label="Anuluj"
      styleClass="customInfoButton outlined"
      (click)="onCancel()"
    ></p-button>
    <p-button
      type="button"
      label="Wybierz"
      styleClass="customInfoButton"
      [disabled]="selectedRecipients().length === 0"
      (click)="onChoose()"
    ></p-button>
  </div>
</div>
